var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import moment from "moment";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { ReactTable } from "@irati/ui/src/Table";
import { H3 } from "@irati/ui/src/Headings";
import Pill from "@irati/ui/src/Pill";
import { injectIntl } from "@irati/utils/lang";
import getTenantWalletTransactions from "@irati/wallet/apollo/query/TenantWalletTransactionsWithStats";
import ErrorText from "@irati/ui/src/ErrorText";
import Columns from "../Columns";
import DownloadReport from "../DownloadReport";
import { TableWrapper, Flex, TransactionsPill, MarginLeft, FullWidthHr } from "./styled";
var LIMIT = 5;
var DEFAULT_PAGE = 0;
var DEFAULT_AMOUNT = "all";
var Transactions = /** @class */ (function (_super) {
    __extends(Transactions, _super);
    function Transactions(props) {
        var _this = _super.call(this, props) || this;
        _this.getTransactions = function (variables) {
            return getTenantWalletTransactions(variables)
                .catch(function () { return _this.setState({ load: null, data: [] }); })
                .then(_this.buildDataAndPages);
        };
        _this.buildDataAndPages = function (res) {
            var total = res ? res.tenantWalletTransactions.total : 0;
            var pages = res ? Math.ceil(total / LIMIT) : 0;
            _this.setState({ total: total, data: _this.formatTableData(res), pages: pages, load: null });
        };
        _this.handlePageChange = function (newPage) {
            var _a = _this.state, walletTypeIds = _a.walletTypeIds, minDate = _a.minDate, maxDate = _a.maxDate, amount = _a.amount;
            var variables = {
                offset: LIMIT * newPage,
                walletTypeIds: walletTypeIds,
                maxDate: maxDate,
                minDate: minDate,
                amount: amount
            };
            _this.setState({
                page: newPage,
                offset: newPage + 1,
                load: _this.getTransactions(variables)
            });
        };
        _this.updateDate = function (date) {
            var _a = _this.state, walletTypeIds = _a.walletTypeIds, amount = _a.amount;
            var minDate = date.from;
            var maxDate = date.to;
            var variables = {
                minDate: minDate,
                maxDate: maxDate,
                walletTypeIds: walletTypeIds,
                amount: amount
            };
            _this.setState({
                page: DEFAULT_PAGE,
                minDate: minDate,
                maxDate: maxDate,
                load: _this.getTransactions(variables)
            });
        };
        _this.updateUsers = function (users) {
            var _a = _this.state, minDate = _a.minDate, maxDate = _a.maxDate, amount = _a.amount;
            var walletTypeIds = users.join(",");
            var variables = {
                walletTypeIds: walletTypeIds,
                minDate: minDate,
                maxDate: maxDate,
                amount: amount
            };
            _this.setState({
                page: DEFAULT_PAGE,
                walletTypeIds: walletTypeIds,
                load: _this.getTransactions(variables)
            });
        };
        _this.updateAmount = function (amount) {
            var _a = _this.state, minDate = _a.minDate, maxDate = _a.maxDate, walletTypeIds = _a.walletTypeIds;
            var uuid = _this.props.auth.business.uuid;
            var variables = {
                tenantId: uuid,
                walletTypeIds: walletTypeIds,
                minDate: minDate,
                maxDate: maxDate,
                amount: amount
            };
            _this.setState({
                page: DEFAULT_PAGE,
                amount: amount,
                load: _this.getTransactions(variables)
            });
        };
        _this.formatTableData = function (data) {
            if (!data || !data.tenantWalletTransactions) {
                return [];
            }
            return data.tenantWalletTransactions.results.map(function (transactionData) {
                return {
                    date: transactionData.date && moment(transactionData.date).format("DD/MM/YYYY"),
                    method: transactionData.method,
                    by: transactionData && transactionData.actionedByUser,
                    to: transactionData && transactionData.senderRecipientUser,
                    amount: transactionData.amount.amount,
                    senderRecipientType: transactionData.senderRecipientType
                };
            });
        };
        _this.state = {
            load: _this.getTransactions(),
            page: DEFAULT_PAGE,
            offset: DEFAULT_PAGE + 1,
            pages: 0,
            data: [],
            minDate: null,
            maxDate: null,
            minValue: null,
            maxValue: null,
            amount: DEFAULT_AMOUNT,
            walletTypeIds: null,
            total: null
        };
        return _this;
    }
    Transactions.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var _a = this.state, data = _a.data, page = _a.page, pages = _a.pages, total = _a.total, minDate = _a.minDate, maxDate = _a.maxDate, walletTypeIds = _a.walletTypeIds, amount = _a.amount, load = _a.load;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, null,
                React.createElement(TransactionsPill, null,
                    React.createElement(H3, null, formatMessage({ id: "admin.reportingV2.wallet.tenantTransactions.title" })),
                    React.createElement(MarginLeft, null,
                        React.createElement(Pill, { text: formatMessage({ id: "admin.reportingV2.wallet.tenantTransactions.pill" }, { total: total }) }))),
                React.createElement(DownloadReport, { reportType: "wallet-tenant", from: minDate, to: maxDate, userUuids: walletTypeIds && walletTypeIds.split(","), amount: amount })),
            React.createElement(FullWidthHr, null),
            React.createElement(TableWrapper, null,
                React.createElement(ReactTable, { id: "tenantTransactions", data: data, pages: pages, page: page, loading: load, columns: Columns({
                        formatMessage: formatMessage,
                        updateDate: this.updateDate,
                        updateUsers: this.updateUsers,
                        updateAmount: this.updateAmount
                    }), onPageChange: this.handlePageChange, getPaginationProps: function (allProps) { return (__assign(__assign({}, allProps), { shouldScrollOnUpdate: false })); } })),
            !load &&
                (!data || (data.length <= 0 && React.createElement(ErrorText, null, formatMessage({ id: "admin.reportingV2.wallet.transactions.emptyData" }))))));
    };
    return Transactions;
}(Component));
export default injectIntl(withAuth(Transactions));
